const store = {
  state: {
    access_token: '',
    music_token: '',

    apple_player: null,
    spotify_player: null,

    name: '',

    START_TIME: null,
    /**
     * isrcs: { isrc: {1: spotify_id, 2: apple_id} }
     * markers: { isrc: timestamp }
     */
    tracks: [],

    /**
     * 1 - landing
     * 2 - name
     * 3 - webGL
     */
    view: 1,

    spotify_premium: false,

    APP_NAME: 'keshi - listening experience',
    // API_URL: 'https://32848aa6b15c.ngrok.io'
    // API_URL: 'http://localhost:3000',
    API_URL: 'https://api.storyboard.gg',
    WSS_URL: 'https://chat-server.storyboard.gg'
    // WSS_URL: 'http://localhost:3004'
  },

  setName(name) {
    this.state.name = name;
  },

  setView(view) {
    this.state.view = view;
  },

  setApplePlayer(apple_player) {
    this.state.apple_player = apple_player;
  },

  setSpotifyPlayer(spotify_player) {
    this.state.spotify_player = spotify_player;
  },

  setAccessToken(access_token) {
    this.state.access_token = access_token;
  },

  // set spotify premium
  setSpotifyPremium(premium) {
    this.state.spotify_premium = premium;
  },

  setMusicToken(music_token) {
    this.state.music_token = music_token;
  },

  setStartTime(START_TIME) {
    this.state.START_TIME = START_TIME;
  },

  setTracks(tracks) {
    this.state.setTracks = tracks;
  }
};

export default store;